/**
 * 0 = Em instalacao
 * 1 = Em operacao
 * 2 = Em modernização
 * 3 = Todas
 * 4 = Desinstalação forçada
 * 5 = Desmobilizada
 *
 * @enum {number}
 */
export enum UnitStatus {
  INSTALLATION = '0',
  OPERATION = '1',
  MODERNIZATION = '2',
  ALL = '3',
  FORCED_UNINSTALL = '4',
  DEACTIVATED = '5'
}

export type UnitStatusKey = Exclude<keyof typeof UnitStatus, 'ALL'>;
